import Add from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import React, { ChangeEvent, useState } from 'react';

import { StructureChildProps } from './StructureChild.props';
import { TableWrapper, SwitchGrid } from './StructureChild.styles';
import { ColorProps } from '../../../@types';
import { GridFeatureModeConstant } from '../../../configs/enums';
import { Accordian } from '../../atoms/Accordian';
import { Button, ButtonVariantProps } from '../../atoms/Button';
import { DataGrid } from '../../atoms/DataGrid';
import { FormControlLabel } from '../../atoms/FormControlLabel';
import { Link } from '../../atoms/Link';
import { Switch } from '../../atoms/Switch';
import { Typography } from '../../atoms/Typography';

export const StructureChild: React.FC<StructureChildProps> = ({
  switchLabel = 'Active',
  childrenData,
  hasViewChildrenEditPermission = true,
  onClick,
  onChangeActiveFlag,
  parentStructureType,
  isClientCustomerStructureCreation
}) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  
  const sortedChildrenData = [...childrenData].sort((a, b) => {
    return (b.isActive === true ? 1 : 0) - (a.isActive === true ? 1 : 0);
  });

  const columns: GridColDef[] = [
    {
      field: 'typeName',
      headerName: 'Node Type',
      flex: 0.3,
    },
    {
      field: 'name',
      headerName: 'Name',
      renderCell: (params: GridRenderCellParams) => params.row.id ? <Link href={`/structure/${params.row.id}`}>{params.row.name}</Link> : params.row.name,
      flex: 0.4,
    },
    {
      field: 'id',
      headerName: 'Action',
      sortable: false,
      width: 450,
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) => <Grid container spacing="24px" justifyContent="center" display="flex" width="100%">
        {hasViewChildrenEditPermission &&
          <>
            <Grid size={{ xs: 1 }}>
              <IconButton aria-label="edit" color="primary" onClick={() => onClick && onClick(params.row.type)}>
                <Add />
              </IconButton>
            </Grid>
            <Grid size={{ xs: 1 }}>
              <IconButton aria-label="add" color="primary" onClick={() => onClick && onClick( undefined, params.row.id)}>
                <EditIcon />
              </IconButton>
            </Grid>
          </>
        }
        <SwitchGrid size={{ xs: 1 }} marginLeft={2}>
          <FormControlLabel
            control={
              <Switch
                disabled={!hasViewChildrenEditPermission}
                color={ColorProps.Success}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeActiveFlag(e.target.checked, params.row.id)}
                checked={params.row.isActive}
              />
            }
            label={switchLabel}
          />
        </SwitchGrid>
      </Grid>
    }
  ];

  return (
    <Accordian
      title={
        <Grid container alignItems="center" flex={1}>
          <Grid size={{ sm: 'grow' }} spacing={1} alignItems="center" container display="flex" flex={1}>
            <Grid>
              <Typography>{`Children (${childrenData.length})`}</Typography>
            </Grid>
            {hasViewChildrenEditPermission &&
              <Grid marginLeft="auto" marginRight="10px">
                <Button variant={ButtonVariantProps.Primary} onClick={(e) => { e.stopPropagation(); onClick && onClick(isClientCustomerStructureCreation ? parentStructureType : ''); }}>Add</Button>
              </Grid>
            }
          </Grid>
        </Grid>
      }
    >
      <TableWrapper>
        <DataGrid
          columns={columns}
          rows={sortedChildrenData}
          rowCount={sortedChildrenData.length}
          disableColumnFilter={true}
          disableColumnSelector={true}
          disableDensitySelector={true}
          page={page}
          pageSize={pageSize}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          paginationMode={GridFeatureModeConstant.client}
          getRowClassName={(params) => !params.row.isActive ? 'gray-out-row' : ''}
          rowsPerPageOptions={[15,30,100]}
          pagination
          componentsProps={{
            toolbar: {
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
              showQuickFilter: false
            }
          }}
        />
      </TableWrapper>
    </Accordian>
  );
};